import { Transition } from '@headlessui/react';
import { memo, useMemo, useRef } from 'react';
import { getTextElementById } from './utils';
import TextElementTypographyPopover from './popovers/TextElementTypographyPopover';
import TextElementAnimationPopover from './popovers/TextElementAnimationPopover';
import TextElementShadowPopover from './popovers/TextElementShadowPopover';
import TextElementOutlinePopover from './popovers/TextElementOutlinePopover';
import TextElementBackgroundPopover from './popovers/TextElementBackgroundPopover';
import TextElementActions from './popovers/TextElementActions';
import { classnames } from '@/libs/utils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

function TextElementMenu({ textElementId }: { textElementId: string }) {
  const { clipData } = useClipsContext();
  const menuRef = useRef<HTMLDivElement>(null);

  const selectedElement = useMemo(() => {
    return getTextElementById(clipData, textElementId);
  }, [clipData, textElementId]);

  if (!selectedElement) {
    return null;
  }

  return (
    <Transition
      appear
      as="div"
      show
      className="z-[60] flex cursor-auto items-center justify-center transition-all duration-100"
      enterFrom="opacity-0 max-h-0"
      enterTo="opacity-100 max-h-96"
      leaveFrom="opacity-100 max-h-96"
      leaveTo="opacity-0 max-h-0"
    >
      <div
        id="text-element-menu"
        onPointerDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
        className={classnames('relative flex rounded-lg border bg-white shadow')}
        ref={menuRef}
      >
        <div className="flex p-1">
          <TextElementTypographyPopover textElementId={textElementId} />
          <TextElementOutlinePopover textElementId={textElementId} />
          <TextElementShadowPopover textElementId={textElementId} />
          <TextElementBackgroundPopover textElementId={textElementId} />
          <TextElementAnimationPopover textElementId={textElementId} />
          <div className="mx-1 h-7 w-px self-center bg-slate-200" />
          <TextElementActions textElementId={textElementId} />
        </div>
      </div>
    </Transition>
  );
}

export default memo(TextElementMenu);
